import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Plug, CheckCircle2, AlertCircle, BookOpen } from "lucide-react";
import ApiKeysPanel from "../components/integrations/ApiKeysPanel";
import WebhooksPanel from "../components/integrations/WebhooksPanel";
import DemoDataPanel from "../components/integrations/DemoDataPanel";
import OneDrivePanel from "../components/integrations/OneDrivePanel";
import GmailPanel from "../components/integrations/GmailPanel";
import FicPanel from "../components/integrations/FicPanel";
import ModelliContrattoPanel from "../components/integrations/ModelliContrattoPanel";
import SnapshotPanel from "../components/integrations/SnapshotPanel";
import WhatsAppPanel, { MotoreAiPanel } from "../components/integrations/WhatsAppPanel";
import { UsersPanel } from "../components/integrations/UsersPanel";
import WhatsAppSetup from "../components/integrations/WhatsAppSetup";
import WhatsAppCoexistence from "../components/integrations/WhatsAppCoexistence";
import ComandoRapidoPanel from "../components/integrations/ComandoRapidoPanel";

const Row = ({ title, ok, children }) => (
  <Card className="p-4 space-y-2" data-testid={`integration-${title.toLowerCase().replace(/ /g, "-")}`}>
    <div className="flex items-center justify-between"><div className="font-semibold">{title}</div>{ok ? <Badge className="bg-emerald-600"><CheckCircle2 className="w-3 h-3 mr-1" />configurato</Badge> : <Badge variant="outline" className="border-amber-400 text-amber-700"><AlertCircle className="w-3 h-3 mr-1" />da configurare</Badge>}</div>
    <div className="text-sm text-muted-foreground">{children}</div>
  </Card>
);

export default function Integrations() {
  const [s, setS] = useState(null);
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/integrations/status").then((r) => setS(r.data)).catch(() => {}); api.get("/integrations/guide").then((r) => setG(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-muted-foreground">Caricamento...</div>;
  return (
    <div className="space-y-5" data-testid="page-integrations">
      <div><h1 className="text-3xl font-display font-bold text-primary flex items-center gap-2"><Plug className="w-7 h-7" /> Integrazioni</h1><p className="text-sm text-muted-foreground">Collegamenti esterni, chiavi API e webhook per app come Wingman</p></div>
      <MotoreAiPanel />
      <UsersPanel />
      <ComandoRapidoPanel />
      <WhatsAppSetup />
      <WhatsAppCoexistence />
      <WhatsAppPanel />
      <SnapshotPanel />
      <DemoDataPanel />
      <OneDrivePanel />
      <GmailPanel />
      <FicPanel />
      <ModelliContrattoPanel />
      <ApiKeysPanel />
      <WebhooksPanel />
      {g && <Card className="p-4 space-y-2" data-testid="api-guide">
        <div className="font-semibold flex items-center gap-2"><BookOpen className="w-4 h-4" /> Guida rapida per collegare Wingman</div>
        <div className="text-xs space-y-1">
          <div>Base URL: <code className="bg-muted px-1 rounded">{g.base_url}</code> · Autenticazione: header <code className="bg-muted px-1 rounded">{g.auth.header}</code> · Documentazione OpenAPI: <a className="underline" href={g.docs} target="_blank" rel="noreferrer">{g.docs}</a></div>
          <div className="font-mono bg-muted rounded p-2 break-all">{g.auth.esempio}</div>
          <table className="w-full text-xs mt-2"><tbody>{g.endpoint_principali.map((e) => <tr key={e.p} className="border-t"><td className="py-1 pr-2 font-mono whitespace-nowrap align-top">{e.m}</td><td className="py-1 pr-2 font-mono align-top">{e.p}</td><td className="py-1 text-muted-foreground">{e.d}</td></tr>)}</tbody></table>
          <div className="text-muted-foreground mt-2">{g.note.join(" · ")}</div>
        </div>
      </Card>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Row title="Fatture in Cloud (SDI)" ok={s.fatture_in_cloud.configurato}>Collegamento OAuth per società nel riquadro «Fatture in Cloud» qui sopra. Dal menu fattura usa "Trasmetti a SDI (Fatture in Cloud)".</Row>
        <Row title="Open Banking PSD2" ok={s.open_banking.configurato}>{s.open_banking.istruzioni}</Row>
        <Row title="Email transazionali" ok={s.email.configurato}>Mittente: <strong>{s.email.mittente}</strong>. Configura destinatari e automazioni nelle sezioni Notifiche email e Automazioni.</Row>
        <Row title="Storage documenti" ok={s.storage.configurato}>Archivio file cifrato su Emergent Object Storage: documenti, foto, contratti, rogiti per operazioni e unità.</Row>
      </div>
    </div>
  );
}
